import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ApplicationState } from '@/state/root.models'

import { useChartCardPagination } from '@/views/personalization-engine/hooks'
import { ChartCardComponent } from '../chart-content'

export const GameCategoriesComponent = () => {
  const { t } = useTranslation()

  const { gameCategory, isLoadingGameCategory } = useSelector(
    ({ personalizationEngine }: ApplicationState) => personalizationEngine,
  )

  const { paginatedRows, pagination, handleChangeLimit, handleChangePage } =
    useChartCardPagination({ data: gameCategory })

  return (
    <ChartCardComponent
      data={gameCategory}
      paginatedRows={paginatedRows}
      title={t('personalizationEngine.gameCategory')}
      isLoading={isLoadingGameCategory}
      pagination={pagination}
      handleChangeLimit={handleChangeLimit}
      handleChangePage={handleChangePage}
    />
  )
}
